import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  SponsoredProductsReportsFilterDto,
  SponsoredProductsReportsFilterModelView,
} from '~/types';

export const GET_SPONSORED_PRODUCTS_REPORTS_FILTER_QUERY_KEY =
  'GET_SPONSORED_PRODUCTS_REPORTS_FILTER_QUERY';

export function getSponsoredProductsReportsFilter(
  params: SponsoredProductsReportsFilterDto
) {
  const clearedParams = clearParams(
    params
  ) as SponsoredProductsReportsFilterDto;
  const requestParams = {
    ...clearedParams,
    segments: JSON.stringify(params.segments),
  };

  return serviceApi.get<SponsoredProductsReportsFilterModelView>(
    `/ReportProdutoPatrocinado/Filter-List`,
    {
      params: requestParams,
    }
  );
}

export function getSponsoredProductsReportsFilterTotal(
  params: SponsoredProductsReportsFilterDto
) {
  const clearedParams = clearParams(
    params
  ) as SponsoredProductsReportsFilterDto;

  return serviceApi.get<SponsoredProductsReportsFilterModelView>(
    `/ReportProdutoPatrocinado/Filter-Total`,
    {
      params: clearedParams,
    }
  );
}
